import { esusApi } from "@/services/api";

export type ResumeIndicatorM1Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorM1Data {
	totalAttendances: number = 0;
	totalCitizens: number = 0;
}

export async function getResumeIndicatorM1({ uf, ibgeCode, ...params }: ResumeIndicatorM1Params) {
	const response = await esusApi.get<ResumeIndicatorM1Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m1/resume`,
		params
	);
	return response.data || new ResumeIndicatorM1Data();
}
